import _ from 'lodash';

export function formatMultilineList(items?: string[]): string {
  return (items || []).join('\n');
}

export function parseMultilineList(value: string): string[] {
  return _(value.split('\n')).map((line) => line.trim()).compact().value();
}

export function validateCustomLoginCheckUrl(url: string): boolean {
  const trimmed = url.trim();
  if (!trimmed) {
    return false;
  }
  try {
    const forParse = trimmed.replace(/\{[^/{}]+\}/g, 'x');
    const uri = new URL(forParse);
    const host = uri.hostname;
    if (uri.protocol !== 'https:') {
      return false;
    }
    if (!host || uri.username || uri.password) {
      return false;
    }
    if (trimmed.includes(',')) {
      return false;
    }
    if (host.startsWith('[') || /^[0-9.]+$/.test(host) || host.toLowerCase() === 'localhost') {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export function validateAppConfiguration(urls: string[], fields: string[]): string | null {
  if (_.isEmpty(urls)) {
    return null;
  }
  const invalidUrl = urls.find((url) => !validateCustomLoginCheckUrl(url));
  if (invalidUrl) {
    return 'domains.domainAppConfigurationInvalidUrl';
  }
  const normalizedFields = fields.map((field) => field.trim()).filter(Boolean);
  if (_.isEmpty(normalizedFields)) {
    return 'domains.domainAppConfigurationFieldsRequired';
  }
  return null;
}
